import { HttpHandler } from 'msw'

import { getAllMachines } from './getAllMachines'
import { getMachine } from './getMachine'
import { updateMachine } from './updateMachine'

export const all: HttpHandler[] = [getAllMachines, getMachine, updateMachine]
